import React from 'react';
const layers = [{
  name: 'Noetivra Workspace',
  caption: 'Where people work',
  chips: ['Research', 'Government', 'Education', 'Clinical', '…'],
  tone: 'bg-white shadow-glow'
}, {
  name: 'Connected Modules',
  caption: 'Configured per organization',
  chips: ['Knowledge', 'Capability', 'Services', 'Credentials'],
  tone: 'glass'
}, {
  name: 'Noetivra Core',
  caption: 'The shared foundation',
  chips: ['Identity & roles', 'Records', 'Activity history', 'Configuration'],
  tone: 'bg-ink text-white'
}];

/** Three stacked planes showing the product architecture. */
export function LayerStack() {
  return <div className="relative mx-auto max-w-lg" role="img" aria-label="Noetivra Workspace sits on Connected Modules, which sit on Noetivra Core" data-id="element-290" data-mp="32enq0pi3ytow">
      {layers.map((layer, i) => <div key={layer.name} className={`relative rounded-[22px] p-5 ${layer.tone} ${i > 0 ? '-mt-3' : ''}`} style={{
      zIndex: layers.length - i,
      marginLeft: `${i * 14}px`,
      marginRight: `${(layers.length - 1 - i) * 14}px`
    }} data-id="element-291" data-mp="3besx0yje3q2j" data-mpi={i}>
          <div className="flex items-baseline justify-between gap-3" data-id="element-292" data-mp="1dwps9gw5ymqd">
            <p className="text-[15px] font-semibold tracking-tight" data-id="element-293" data-mp="19vw3klawd3wf">{layer.name}</p>
            <p className={`text-[12px] ${i === 2 ? 'text-white/60' : 'text-ink-muted'}`} data-id="element-294" data-mp="19y0evob4l56q">{layer.caption}</p>
          </div>
          <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-295" data-mp="21nv7puy6zd05">
            {layer.chips.map(c => <span key={c} className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${i === 2 ? 'bg-white/10 text-white/85' : i === 0 ? 'bg-accent-soft text-accent-ink' : 'bg-white/80 text-ink-soft'}`} data-id="element-296" data-mp="1xl8afeir4zvk">
                {c}
              </span>)}
          </div>
        </div>)}
    </div>;
}